const finiteNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getAnimationAudioGain = (layer, localTime) => {
  const duration = Math.max(0, finiteNumber(layer?.duration, 0));
  if (duration <= 0) return 1;

  const legacyDuration = Math.max(0, finiteNumber(layer?.animation_duration, 0.5));
  const entranceDuration = Math.min(
    duration / 2,
    Math.max(0, finiteNumber(layer?.entrance_animation_duration, legacyDuration))
  );
  const exitDuration = Math.min(
    duration / 2,
    Math.max(0, finiteNumber(layer?.exit_animation_duration, legacyDuration))
  );
  const time = Math.max(0, Math.min(duration, finiteNumber(localTime, 0)));
  let gain = 1;

  if (layer?.entrance_animation && layer.entrance_animation !== "none" && entranceDuration > 0) {
    gain = Math.min(gain, time / entranceDuration);
  }
  if (layer?.exit_animation && layer.exit_animation !== "none" && exitDuration > 0) {
    gain = Math.min(gain, (duration - time) / exitDuration);
  }
  return Math.max(0, Math.min(1, gain));
};
